var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"productsSection container"},[_c('SectionContainer',{attrs:{"title":_vm.data.title}},[_c('div',{staticClass:"productsSection__content"},[_c('SliderTiles',{attrs:{"slides-per-view":"auto","content-type":"product","items":_vm.items,"nav-buttons-type":"rounded"}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }